import { render, staticRenderFns } from "./busiInfo.vue?vue&type=template&id=0b04ba0b&scoped=true"
import script from "./busiInfo.vue?vue&type=script&lang=js"
export * from "./busiInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b04ba0b",
  null
  
)

export default component.exports